export const cielumData = {
    logo:"/img/logo.png",
};
export const error404Data = {
    logo:"/img/logo.png",
    cara:"/img/Grupo 9514.svg",
    desgrade:"/img/elipse-221-18@1x.png",
};
export const rectanguloData = {
    logo:"/img/logo.png",
    imgen:"/img/Grupo 9377 MENSAJE ENVIADO CON ÉXITO.svg",
    circulo:"/img/elipse-221-18@1x.png",
};

export const loginData = {
    cielumProps:"/img/Sin título.png",
    logo:"/img/logo.png",  
    logosura: "/img/logogris.webp", 
    ingresoAlSistemaPrm: "Ingreso al sistema de Oxígeno",
    Recordar:"Recordar",
    email:"Correo electrónico",
    passworde:"Contraseña",
    ingreso:"Ingresar",
    eye:"/img/Grupo 9243 OJO ÍCONO CONTRASEÑA.svg",
    ingreseUnCorreoElectrnico: "Ingrese un correo electrónico.",
    errorCorreo: "El formato de correo no es válido, inténtelo de nuevo.",
    ingreseUnaContrasea: "Ingrese una contraseña.",
    datosincorrectos: "Su correo electrónico o contraseña son errados, inténtelo de nuevo.",
    inactivo: "El usuario ingresado se encuentra inactivo",
    proceso:"Debe finalizar el proceso de registro para ingresa",

   
};

export const cambioContraseaData = {
    logo:"/img/logo.png",
    prmCielum: "Cambio de contraseña",
    passworde:"Nueva contraseña",
    confirpasswordd:"Confirmar contraseña",
    children: "Ingresar",
    laContraseaDebeC: "La contraseña debe cumplir con las siguientes condiciones:",
    intentosContra:"Nueva Contraseña utilizada con anterioridad, digite otra contraseña. Recuerde que no debe emplear contraseñas que ha registrado en las 3 ocasiones anteriores.",
    carateresocho:"Más de 8 Caracteres.",
    caratermayus:"Mínimo 1 Mayúscula.",
    caraterminus:"Mínimo 1 minúscula",
    caraterespecial:"Mínimo 1 Carácter especial(@, _, #, &...).",
    nocondiciones:"La contraseña ingresada no cumple con las condiciones indicadas.",
    nocoinciden:"Las contraseñas no coinciden.",  
    campos:"Ingrese contraseña",
};
export const modalData = {
    logo:"/img/logo.png",
    imgen:"/img/Grupo 9390 ÍCONO CONTRASEÑA CAMBIADA EXITOSAMENTE.svg",
}

export const error401Data = {
    logo:"/img/logo.png",   
      cara:"/img/Grupo 9526.svg",
    desgrade:"/img/elipse-221-18@1x.png",
};
export const error500Data = {
    logo:"/img/logo.png",
     cara:"/img/grupo  9520 - 500.svg",
    desgrade:"/img/elipse-221-18@1x.png",
};
export const CreacioncontrasenaslideData = {
    logo:"/img/logo.png",
    prmCielum: "Crear contraseña",
  passworde:"Nueva contraseña",
  confirpasswordd:"Confirmar contraseña",
  children: "Ingresar",
  laContraseaDebeC: "La contraseña debe cumplir con las siguientes condiciones:",
  intentosContra:"Nueva Contraseña utilizada con anterioridad, digite otra contraseña. Recuerde que no debe emplear contraseñas que ha registrado en las 3 ocasiones anteriores.",
  carateresocho:"Más de 8 Caracteres.",
  caratermayus:"Mínimo 1 Mayúscula.",
  caraterminus:"Mínimo 1 minúscula",
  caraterespecial:"Mínimo 1 Carácter especial(@, _, #, &...).",
  nocondiciones:"La contraseña ingresada no cumple con las condiciones indicadas.",
  nocoinciden:"Las contraseñas no coinciden.",  
  };

  export const CambiosContraseaInicioData = {
    logo:"/img/logo.png",
     prmCielum: "Cambio de contraseña",
     passworde:"Nueva contraseña",
     confirpasswordd:"Confirmar contraseña",
     children: "Ingresar",
     laContraseaDebeC: "La contraseña debe cumplir con las siguientes condiciones:",
     intentosContra:"Nueva Contraseña utilizada con anterioridad, digite otra contraseña. Recuerde que no debe emplear contraseñas que ha registrado en las 3 ocasiones anteriores.",
     carateresocho:"Más de 8 Caracteres.",
     caratermayus:"Mínimo 1 Mayúscula.",
     caraterminus:"Mínimo 1 minúscula",
     caraterespecial:"Mínimo 1 Carácter especial(@, _, #, &...).",
     nocondiciones:"La contraseña ingresada no cumple con las condiciones indicadas.",
     nocoinciden:"Las contraseñas no coinciden.",  
     campos:"Ingrese contraseña", 
   };
  

export const inicioData = {
    grupo120: "/img/rect-ngulo-26@1x.png",
    grupo119: "/img/trazado-117-1x-png@1x.png",
    src: "/img/grupo-103@1x.png",
    grupo109: "/img/trazado-155-1x-png@1x.png",
    grupo110: "/img/trazado-156-1x-png@1x.png",
    trazado126: "/img/trazado-157@1x.png",
    trazado127: "/img/trazado-158@1x.png",
    trazado128: "/img/trazado-159-1x-png@1x.png",
    trazado129: "/img/trazado-160@1x.png",
    trazado130: "/img/trazado-161@1x.png",
    trazado131: "/img/trazado-162-1x-png@1x.png",
    grupo1979: "/img/trazado-129@1x.png",
    bienvenidoUsuarioPortalClnico: "Bienvenido [Usuario Portal Clínico]",
    lnea2: "/img/l-nea-2@1x.png",
    grupo87: "/img/grupo-87@1x.png",
    elipse1: "/img/elipse-1@1x.png",
    trazado111: "/img/trazado-111-1x-png@1x.png",
    elipse2: "/img/elipse-2@1x.png",
    trazado112: "/img/trazado-112-1x-png@1x.png",
    overlapGroup2: "/img/elipse-3@1x.png",
    trazado113: "/img/trazado-113@1x.png",
    elipse4: "/img/elipse-4@1x.png",
    trazado114: "/img/trazado-114-1x-png@1x.png",
    elipse7: "/img/elipse-7@1x.png",
    overlapGroup6: "/img/elipse-9@1x.png",
    elipse11: "/img/elipse-11@1x.png",
    elipse13: "/img/elipse-13@1x.png",
    trazado205: "/img/trazado-115-1x-png@1x.png",
    lnea4: "/img/trazado-116-1x-png@1x.png",
    rectngulo22: "/img/rect-ngulo-20@1x.png",
    trazado133: "/img/trazado-118-1x-png@1x.png",
    lnea5: "/img/trazado-119-1x-png@1x.png",
    trazado134: "/img/trazado-120-1x-png@1x.png",
    trazado135: "/img/trazado-121-1x-png@1x.png",
    trazado136: "/img/trazado-122-1x-png-1@1x.png",
    trazado137: "/img/trazado-123-1x-png@1x.png",
    trazado138: "/img/trazado-124-1x-png-1@1x.png",
    trazado181: "/img/trazado-125-1x-png@1x.png",
    trazado179: "/img/trazado-126-1x-png@1x.png",
    trazado180: "/img/trazado-127-1x-png-1@1x.png",
    trazado178: "/img/trazado-128-1x-png@1x.png",
    pacientes: "Pacientes",
    grupo105: "/img/trazado-130-1x-png@1x.png",
    lnea3: "/img/l-nea-3@1x.png",
    trazado120: "/img/l-nea-4@1x.png",
    trazado139: "/img/l-nea-5@1x.png",
    trazado155: "/img/trazado-146-1x-png@1x.png",
    trazado158: "/img/trazado-149@1x.png",
    trazado161: "/img/trazado-152@1x.png",
    trazado156: "/img/trazado-147@1x.png",
    trazado159: "/img/trazado-150-1x-png@1x.png",
    trazado162: "/img/trazado-153@1x.png",
    trazado157: "/img/trazado-148-1x-png@1x.png",
    trazado160: "/img/trazado-151@1x.png",
    trazado163: "/img/trazado-154@1x.png",
    grupo125: "/img/grupo-115@1x.png",
    grupo124: "/img/trazado-132-1x-png-1@1x.png",
    grupo123: "/img/trazado-133-1x-png@1x.png",
    grupo122: "/img/grupo-112@1x.png",
    iconSearch: "/img/trazado-135-1x-png@1x.png",
    trazado121: "/img/trazado-136-1x-png@1x.png",
    iconUser: "/img/trazado-131-1x-png@1x.png",
    health1: "health",
    trazado174: "/img/trazado-165-1x-png@1x.png",
    trazado145: "/img/trazado-168-1x-png@1x.png",
    trazado144: "/img/trazado-166-1x-png@1x.png",
    trazado175: "/img/trazado-167-1x-png@1x.png",
    iconStar: "/img/trazado-164-1x-png@1x.png",
    trazado177: "/img/trazado-163@1x.png",
    dataAnalytics: "Por favor seleccione la aplicación a la que desea ingresar",
    trazado119: "/img/grupo-127@1x.png",
    she: "Articulación de rutas<br />integrales en salud",
    overlapGroup17: "/img/trazado-186-1x-png@1x.png",
    trazado200: "/img/trazado-187@1x.png",
    trazado201: "/img/trazado-188-1x-png@1x.png",
    trazado122: "/img/trazado-189@1x.png",
    trazado203: "/img/trazado-190@1x.png",
    trazado204: "/img/trazado-191-1x-png@1x.png",
    iconCursor: "/img/trazado-192@1x.png",
    trazado202: "/img/trazado-193@1x.png",
    trazado118: "/img/trazado-194-1x-png@1x.png",
    iconBookmark: "/img/trazado-195-1x-png@1x.png",
    grupo139: "/img/trazado-196@1x.png",
    articulacinDeRuta: "P2H",
    trazado176: "/img/grupo-131@1x.png",
    p2H: "DATA<br />ANALYTICS",
    trazado173: "/img/grupo-129@1x.png",
    porFavorSeleccione: "SHE",
    health2: "Aceptar",
};

export const RecuperarcontrasenaData = {
    cielumProps:cielumData,
    title: "HELPHARMA - OXYFLOW",
    circulo:"/img/elipse-221-18@1x.png",
    overlapGroup2: "/img/trazado-572@1x.png",
    recuperarContrasea: "Recuperar contraseña",
    siHaOlvidadoSuCo: "Si ha olvidado su contraseña no se preocupe.",
    ingreseSuCorreoEl: "Ingrese su Correo Electrónico y le enviaremos instrucciones de cómo cambiarla.",
    correoElectrnico: "Correo Electrónico",
    ejemploCorreoCom: "ejemplo@correo.com",
    enviar: "Enviar",
    datos:"El usuario ingresado se encuentra inactivo, solicita al administrador activarlo nuevamente.",
    grupo8: "/img/trazado-492@1x.png",
    grupo9: "/img/trazado-493@1x.png",
    trazado11: "/img/trazado-494@1x.png",
    trazado12: "/img/trazado-495@1x.png",
    trazado13: "/img/trazado-496@1x.png",
    trazado14: "/img/trazado-497@1x.png",
    trazado15: "/img/trazado-498@1x.png",
    trazado16: "/img/trazado-499@1x.png",
    grupo15: "/img/trazado-500@1x.png",
    grupo16: "/img/trazado-501@1x.png",
    trazado19: "/img/trazado-502@1x.png",
    trazado20: "/img/trazado-503@1x.png",
    trazado21: "/img/trazado-504@1x.png",
    trazado22: "/img/trazado-505@1x.png",
    trazado23: "/img/trazado-506@1x.png",
    trazado24: "/img/trazado-507@1x.png",
    grupo22: "/img/trazado-508@1x.png",
    grupo23: "/img/trazado-509@1x.png",
    trazado27: "/img/trazado-510@1x.png",
    trazado28: "/img/trazado-511@1x.png",
    trazado29: "/img/trazado-512@1x.png",
    trazado30: "/img/trazado-513@1x.png",
    trazado31: "/img/trazado-514@1x.png",
    trazado32: "/img/trazado-515@1x.png",
    grupo64: "/img/trazado-556@1x.png",
    grupo65: "/img/trazado-557@1x.png",
    trazado75: "/img/trazado-558@1x.png",
    trazado76: "/img/trazado-559@1x.png",
    trazado77: "/img/trazado-560@1x.png",
    trazado78: "/img/trazado-561@1x.png",
    trazado79: "/img/trazado-562@1x.png",
    trazado80: "/img/trazado-563@1x.png",
    grupo50: "/img/trazado-540@1x.png",
    grupo51: "/img/trazado-541@1x.png",
    trazado59: "/img/trazado-542@1x.png",
    trazado60: "/img/trazado-543@1x.png",
    trazado61: "/img/trazado-544@1x.png",
    trazado62: "/img/trazado-545@1x.png",
    trazado63: "/img/trazado-546@1x.png",
    trazado64: "/img/trazado-547@1x.png",
    grupo1: "/img/trazado-484@1x.png",
    grupo2: "/img/trazado-485@1x.png",
    trazado3: "/img/trazado-486@1x.png",
    trazado4: "/img/trazado-487@1x.png",
    trazado5: "/img/trazado-488@1x.png",
    trazado7: "/img/trazado-490@1x.png",
    trazado8: "/img/trazado-491@1x.png",
    grupo36: "/img/trazado-524@1x.png",
    grupo37: "/img/trazado-525@1x.png",
    trazado43: "/img/trazado-526@1x.png",
    trazado44: "/img/trazado-527@1x.png",
    trazado45: "/img/trazado-528@1x.png",
    trazado47: "/img/trazado-530@1x.png",
    trazado48: "/img/trazado-531@1x.png",
    grupo57: "/img/trazado-548@1x.png",
    grupo58: "/img/trazado-549@1x.png",
    trazado67: "/img/trazado-550@1x.png",
    trazado68: "/img/trazado-551@1x.png",
    trazado69: "/img/trazado-552@1x.png",
    trazado70: "/img/trazado-553@1x.png",
    trazado71: "/img/trazado-554@1x.png",
    trazado72: "/img/trazado-555@1x.png",
    grupo71: "/img/trazado-564@1x.png",
    grupo72: "/img/trazado-565@1x.png",
    trazado83: "/img/trazado-566@1x.png",
    trazado84: "/img/trazado-567@1x.png",
    trazado85: "/img/trazado-568@1x.png",
    trazado86: "/img/trazado-569@1x.png",
    trazado87: "/img/trazado-570@1x.png",
    trazado88: "/img/trazado-571@1x.png",
    grupo43: "/img/trazado-532@1x.png",
    grupo44: "/img/trazado-533@1x.png",
    trazado51: "/img/trazado-534@1x.png",
    trazado52: "/img/trazado-535@1x.png",
    trazado53: "/img/trazado-536@1x.png",
    trazado54: "/img/trazado-537@1x.png",
    trazado55: "/img/trazado-538@1x.png",
    trazado56: "/img/trazado-539@1x.png",
    grupo29: "/img/trazado-516@1x.png",
    grupo30: "/img/trazado-517@1x.png",
    trazado35: "/img/trazado-518@1x.png",
    trazado36: "/img/trazado-519@1x.png",
    trazado37: "/img/trazado-520@1x.png",
    trazado38: "/img/trazado-521@1x.png",
    trazado39: "/img/trazado-522@1x.png",
    trazado40: "/img/trazado-523@1x.png",
};


export const ModalErrorData = {
    prmCielum1: "OXYFLOW",
  portalClnicoCielum: "Portal Clínico Cielum",
  inicioDeSesin1: "Inicio de Sesión",
  prmCielum3:
    "Ha superado la cantidad de intentos permitidos para ingresar. Será dirigido a la opción de recuperación de contraseña",
  prmCielum2: "Recuperar Contraseña",
  trazado11: "/img/trazado-11-1x-png@1x.png",
  trazado12: "/img/trazado-12@1x.png",
  trazado13: "/img/trazado-13-1x-png@1x.png",
  trazado14: "/img/trazado-14@1x.png",
  trazado15: "/img/trazado-15@1x.png",
  trazado16: "/img/trazado-16@1x.png",
  grupo15: "/img/trazado-17@1x.png",
  grupo16: "/img/trazado-18-1x-png@1x.png",
  trazado19: "/img/trazado-19@1x.png",
  trazado20: "/img/trazado-20@1x.png",
  trazado21: "/img/trazado-21@1x.png",
  trazado22: "/img/trazado-22@1x.png",
  trazado23: "/img/trazado-23@1x.png",
  trazado24: "/img/trazado-24@1x.png",
  grupo22: "/img/trazado-25@1x.png",
  grupo23: "/img/trazado-26-1x-png@1x.png",
  trazado27: "/img/trazado-27@1x.png",
  trazado28: "/img/trazado-28@1x.png",
  trazado29: "/img/trazado-29@1x.png",
  trazado30: "/img/trazado-30@1x.png",
  trazado31: "/img/trazado-31@1x.png",
  trazado32: "/img/trazado-32@1x.png",
  grupo64: "/img/trazado-73@1x.png",
  grupo65: "/img/trazado-74@1x.png",
  trazado75: "/img/trazado-75@1x.png",
  trazado76: "/img/trazado-76@1x.png",
  trazado77: "/img/trazado-77@1x.png",
  trazado78: "/img/trazado-78@1x.png",
  trazado79: "/img/trazado-79@1x.png",
  trazado80: "/img/trazado-80@1x.png",
  grupo50: "/img/trazado-57@1x.png",
  grupo51: "/img/trazado-58-1x-png@1x.png",
  trazado59: "/img/trazado-59@1x.png",
  trazado60: "/img/trazado-60@1x.png",
  trazado61: "/img/trazado-61@1x.png",
  trazado62: "/img/trazado-62@1x.png",
  trazado63: "/img/trazado-63@1x.png",
  trazado64: "/img/trazado-64-1x-png@1x.png",
  grupo1: "/img/trazado-1@1x.png",
  grupo2: "/img/trazado-2-1x-png@1x.png",
  trazado3: "/img/trazado-3@1x.png",
  trazado4: "/img/trazado-4@1x.png",
  trazado5: "/img/trazado-5@1x.png",
  trazado7: "/img/trazado-7@1x.png",
  trazado8: "/img/trazado-8@1x.png",
  grupo36: "/img/trazado-41@1x.png",
  grupo37: "/img/trazado-42-1x-png@1x.png",
  trazado43: "/img/trazado-43@1x.png",
  trazado44: "/img/trazado-44@1x.png",
  trazado45: "/img/trazado-45@1x.png",
  trazado47: "/img/trazado-47@1x.png",
  trazado48: "/img/trazado-48@1x.png",
  grupo57: "/img/trazado-65@1x.png",
  grupo58: "/img/trazado-66-1x-png@1x.png",
  trazado67: "/img/trazado-67@1x.png",
  trazado68: "/img/trazado-68@1x.png",
  trazado69: "/img/trazado-69@1x.png",
  trazado70: "/img/trazado-70@1x.png",
  trazado71: "/img/trazado-71@1x.png",
  trazado72: "/img/trazado-72@1x.png",
  grupo71: "/img/trazado-81@1x.png",
  grupo72: "/img/trazado-82-1x-png@1x.png",
  trazado83: "/img/trazado-83@1x.png",
  trazado84: "/img/trazado-84@1x.png",
  trazado85: "/img/trazado-85-1x-png@1x.png",
  trazado86: "/img/trazado-86@1x.png",
  trazado87: "/img/trazado-87@1x.png",
  trazado88: "/img/trazado-88@1x.png",
  grupo43: "/img/trazado-49@1x.png",
  grupo44: "/img/trazado-50@1x.png",
  trazado51: "/img/trazado-51@1x.png",
  trazado52: "/img/trazado-52@1x.png",
  trazado53: "/img/trazado-53@1x.png",
  trazado54: "/img/trazado-54@1x.png",
  trazado55: "/img/trazado-55@1x.png",
  trazado56: "/img/trazado-56-1x-png@1x.png",
  grupo29: "/img/trazado-33@1x.png",
  grupo30: "/img/trazado-34-1x-png@1x.png",
  trazado35: "/img/trazado-35@1x.png",
  trazado36: "/img/trazado-36@1x.png",
  trazado37: "/img/trazado-37@1x.png",
  trazado38: "/img/trazado-38@1x.png",
  trazado39: "/img/trazado-39@1x.png",
  trazado40: "/img/trazado-40@1x.png",

}
